import { styled } from '@mui/material';
import {
  BarLabelProps,
  BarPlot,
  ChartContainer,
  ChartsXAxis,
  ChartsYAxis,
} from '@mui/x-charts';
import { useAnimate } from '@mui/x-charts/hooks';

import { translate } from '@/ui/i18n';

type Props = {
  data: {
    [monthKey: string]: {
      score: number;
    };
  };
  color: string;
};
export function Co2Timeline({ data, color }: Props) {
  return (
    <div
      style={{
        border: '1.5px solid black',
        width: '100%',
        borderRadius: '12px',
        overflow: 'hidden',
        maxHeight: '245px',
      }}
    >
      <h2
        style={{
          display: 'flex',
          flexDirection: 'column',
          color: '#322222',
          borderBottom: '1px solid #000',
          backgroundColor: '#FFF7F3',
          margin: '0px',
          fontSize: '21px',
          fontWeight: 700,
          padding: '12px 20px 13px 20px',
          lineHeight: '16px',
          wordWrap: 'break-word',
          borderRadius: '12px 12px 0px 0px',
          width: '100%',
          textAlign: 'left',
        }}
      >
        {translate('PdfExports.co2-without-structure')}
      </h2>
      <ChartContainer
        xAxis={[{ scaleType: 'band', data: Object.keys(data) }]}
        height={200}
        colors={[color || '#C7B4A9']}
        style={{
          marginLeft: '-18px',
        }}
        series={[
          {
            type: 'bar',
            id: 'base',
            data: Object.values(data).map((item) => item.score),
            label: 'value',
          },
        ]}
      >
        <BarPlot barLabel="value" slots={{ barLabel: BarLabel }} />
        <ChartsXAxis />
        <ChartsYAxis />
      </ChartContainer>
    </div>
  );
}

const Text = styled('text')(() => ({
  fontSize: '11px',
  fontWeight: 400,
  textAnchor: 'middle',
  dominantBaseline: 'central',
}));

function BarLabel(props: BarLabelProps) {
  const { x, y, width, ...otherProps } = props;
  const animatedProps = useAnimate({ x: x + width / 2, y: y - 12 }, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transformProps: (p: any) => p,
    skip: true,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any);

  // @ts-ignore
  return <Text {...otherProps} {...animatedProps} />;
}
